import request from '@/axios'
// F-用户服务-02-获取服务用户信息
export function getServiceInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/subscriber/getServiceInfo',
    method: 'post',
    data
  })
}
// F-用户服务-01-获取服务订单
export function getServiceOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/subscriber/getServiceOrder',
    method: 'post',
    data
  })
}
// F-用户服务-03-绑定服务用户(群绑定)
export function bindServiceCustomer(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/subscriber/bindServiceCustomer',
    method: 'post',
    data
  })
}
